<template>
  <div class="row">
    <CareerPlaceholder v-if="loading_career" />
    <div
      v-else
      class="col-12"
    >
      <div
        id="overlay3"
        :style="`opacity: ${(showOverlay && student_overlay_info) ? '1': '0'}`"
      />
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="order-2 order-md-1">
          <PillKind :kind="career.kind_name" />
          <h1 class="explorer-show__title">
            {{ career.name | capitalize }}
          </h1>
          <div class="explorer-show__subtitle">
            {{ career.area_name | lowercase | capitalize }}
          </div>
        </div>
        <div class="order-1 order-md-2">
          <base-button
            small
            :inverse="!starred"
            class="text-nowrap mx-0 mb-2"
            @click="toggleFavorites"
          >
            <fa-icon icon="star" />
            {{ (starred)? 'Agregado a favoritos': 'Agregar a mis favoritos' }}
          </base-button>
        </div>
      </div>

      <!-- <a href="#" class="btn btn-outline-primary btn-sm">
      <fa-icon icon="university"/> Agregar Universidad
            </a>-->

      <AccordionOrTabs
        :tabs="tabs"
        :current-tab="currentTab"
        :disabled="loading_chart_data || (lock_tabs && !error) "
        class="col-12"
        @change-current-tab="changeCurrentTab"
      >
        <template v-if="currentTab == 0">
          <div
            v-if="loading_chart_data"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <div
            v-else-if="salary_error"
            align="center"
          >
            <img
              src="@/assets/img/no_data.png"
              :class="ImageClassIfMobile"
            >
            <h4>Aún no hay datos suficientes</h4>
            <p>Por ahora no hay datos suficientes para visualizar los gráficos.</p>
            <p>Estamos recopilando información para completar esta sección.</p>
          </div>
          <div v-else>
            <div v-if="ask_question[currentTab] && career_mean">
              <SalaryQuestion
                :career-name="career.name"
                :career-average="career_mean"
                @answered="AnswerCallback"
              />
            </div>
            <div v-else>
              <div
                v-if="display_chart_group.bar"
                class="chart-title row d-flex"
              >
                <div class="col-12 col-md-9 align-self-center text-center">
                  {{ CONFIG.textForTabs[0]["barTitle"] }}
                </div>
                <div class="col-12 col-md-3"
                     :class="{overlay_class3: showOverlay && student_overlay_info}"
                >
                  <HelpVideo
                    src="vid/video3_salarios_promedios.mp4"
                    gif_preview="salarios_gif.gif"
                    img_placeholder="salarios_placeholder.png"
                  />
                </div>
              </div>
              <div
                v-if="display_chart_group.bar"
                class="chartSubtitle"
              >
                {{ CONFIG.textForTabs[0]["barSubtitle"] }}
              </div>

              <div
                v-if="display_chart_group.line"
                class="chart-title row d-flex"
              >
                <div class="col-12 col-md-9 align-self-center text-center">
                  {{ CONFIG.textForTabs[0]["lineTitle"] }}
                </div>
                <div class="col-12 col-md-3">
                  <HelpVideo
                    src="vid/video3_salarios_promedios.mp4"
                    gif_preview="salarios_gif.gif"
                    img_placeholder="salarios_placeholder.png"
                  />
                </div>
              </div>
              <h6
                v-if="display_chart_group.line"
                class="chartSubtitle"
              >
                {{ CONFIG.textForTabs[0]["lineSubtitle"] }}
              </h6>
              <div
                v-if="display_chart_group.video"
                align="center"
                class="chart-title"
              >
                {{ CONFIG.textForTabs[0]["videoTitle"] }}
              </div>
              <h6
                v-if="display_chart_group.video"
                class="chartSubtitle"
              >
                {{ CONFIG.textForTabs[0]["videoSubtitle"] }}
              </h6>
              <div v-if="display_chart_group.line">
                <DistributionBarChart
                  :height="170"
                  :chart-data="distributionBarCharData"
                  :colors="distributionBarCharColors"
                  :options="partnersBarChartOptions"
                />
              </div>
              <div v-if="display_chart_group.bar">
                <SalaryIncomeBarChart
                  :height="170"
                  :chart-data="barChartData"
                  :options="barChartOptions"
                />
              </div>

              <div class="container father-of-toolbarbuttons">
                <div class="row foot-bar-char">
                  <ToolbarButton
                    v-if="display_chart_group.bar_button"
                    :selected="display_chart_group.bar"
                    :suffix="display_chart_group.line_button?'first':'middle'"
                    @click="showGraph('bar')"
                  >
                    Promedios
                  </ToolbarButton>
                  <ToolbarButton
                    v-if="display_chart_group.line_button"
                    :selected="display_chart_group.line"
                    :suffix="'last'"
                    @click="showGraph('line')"
                  >
                    Distribución
                  </ToolbarButton>
                  <p
                    class="textAfterToolbarButtons"
                  >
                    {{ CONFIG.textForTabs[0]["bar"] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="currentTab == 1">
          <div
            v-if="loading_chart_data"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <div
            v-else-if="emp_error"
            align="center"
          >
            <img
              src="@/assets/img/no_data.png"
              :class="ImageClassIfMobile"
            >
            <h4>Aún no hay datos suficientes</h4>
            <p>Por ahora no hay datos suficientes para visualizar los gráficos.</p>
            <p>Estamos recopilando información para completar esta sección.</p>
          </div>
          <div v-else>
            <div v-if="ask_question[currentTab] ">
              <EmployabilityQuestion
                :career-average="career_employability_mean"
                :career-name="career.name"
                @answered="AnswerCallback"
              />
            </div>
            <div v-else>
              <div>
                <div class="chart-title row d-flex">
                  <div class="col-12 col-md-9 align-self-center text-center">
                    {{ CONFIG.textForTabs[1]["title"] }}
                  </div>
                  <div class="col-12 col-md-3">
                    <HelpVideo
                      src="vid/video4_empleabilidad.mp4"
                      gif_preview="gif_empleabilidad.gif"
                      img_placeholder="empleabilidad_placeholder.png"
                    />
                  </div>
                </div>
                <!-- <h6
                  class="chartSubtitle"
                >
                  {{ CONFIG.textForTabs[1]["subtitle"] }}
                </h6> -->
                <SalaryIncomeBarChart
                  :height="170"
                  :chart-data="barChartData"
                  :options="employBarChartOptions"
                  :display_legend="true"
                />
              </div>
              <div class="container father-of-toolbarbuttons">
                <div class="row foot-bar-char">
                  <p
                    class="textAfterToolbarButtons"
                  >
                    <span v-html="CONFIG.textForTabs[1]['text']" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="currentTab == 2">
          <div
            v-if="loading_chart_data"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <div
            v-else-if="grades_error"
            align="center"
          >
            <img
              src="@/assets/img/no_data.png"
              :class="ImageClassIfMobile"
            >
            <h4>Aún no hay datos suficientes</h4>
            <p>Por ahora no hay datos suficientes para visualizar los gráficos.</p>
            <p>Estamos recopilando información para completar esta sección.</p>
          </div>
          <div v-else>
            <div v-if="ask_question[currentTab] ">
              <GradesQuestion
                :career-average="career_grades_mean"
                :career-name="career.name"
                @answered="AnswerCallback"
              />
            </div>
            <div
              v-else
              class="father-of-toolbarbuttons"
            >
              <div
                v-if="!is_line_chart"
                class="chart-title"
              >
                {{ CONFIG.textForTabs[2]["barTitle"] }}
              </div>
              <h6
                v-if="!is_line_chart"
                class="chartSubtitle"
              >
                {{ CONFIG.textForTabs[2]["barSubtitle"] }}
              </h6>

              <div
                v-if="is_line_chart"
                class="chart-title row d-flex"
              >
                <div class="col-12 col-md-9 align-self-center text-center">
                  {{ CONFIG.textForTabs[2]["lineTitle"] }}
                </div>
                <div class="col-12 col-md-3">
                  <HelpVideo
                    src="vid/video5_pruebas_nacionales.mp4"
                    gif_preview="gif_pruebas_nacionales.gif"
                    img_placeholder="pruebas_nacionales_placeholder.png"
                  />
                </div>
              </div>
              <h6
                v-if="is_line_chart"
                class="chartSubtitle"
              >
                {{ CONFIG.textForTabs[2]["lineSubtitle"] }}
              </h6>
              <div v-if="!is_line_chart">
                <PartnersBarChart
                  :height="170"
                  :career-uuid="careerUuid"
                  :chart-data="lineChartData"
                  :options="partnersBarChartOptions"
                />
              </div>
              <div v-else>
                <SalaryIncomeBarChart
                  :height="170"
                  :chart-data="barChartData"
                  :options="gradeBarChartOptions"
                  :display_legend="true"
                />
              </div>
              <!--<div class="container father-of-toolbarbuttons">
                <div class="foot-bar-char">
                  <ToolbarButton
                    :selected="!is_line_chart"
                    :suffix="'first'"
                    @click="is_line_chart = false"
                  >
                    Promedios
                  </ToolbarButton>
                  <ToolbarButton
                    :selected="is_line_chart"
                    :suffix="'last'"
                    @click="is_line_chart = true"
                  >
                    Distribución
                  </ToolbarButton>
                </div>
              </div>-->
              <p
                v-if="is_line_chart"
                class="textAfterToolbarButtons"
              >
                {{ CONFIG.textForTabs[2]["bar"] }}
              </p>
              <p
                v-if="!is_line_chart"
                class="textAfterToolbarButtons"
              >
                {{ CONFIG.textForTabs[2]["line"] }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="currentTab == 3">
          <div
            v-if="loading_chart_data"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <div
            v-else-if="pensum_error"
            align="center"
          >
            <img
              src="@/assets/img/no_data.png"
              :class="ImageClassIfMobile"
            >
            <h4>Aún no hay datos suficientes</h4>
            <p>Por ahora no hay datos suficientes para visualizar los gráficos.</p>
            <p>Estamos recopilando información para completar esta sección.</p>
          </div>
          <div
            v-else
            class="father-of-toolbarbuttons"
          >
            <div
              v-if="pensum_chart_choice == 'avg_cuan'"
              class="chart-title row d-flex"
            >
              <div class="col-12 col-md-9 align-self-center text-center">
                {{ CONFIG.textForTabs[3]["avgCuanTitle"] }}
              </div>
              <div class="col-12 col-md-3">
                <HelpVideo
                  src="vid/video6_pensum.mp4"
                  gif_preview="gif_pensum.gif"
                  img_placeholder="pensum_placeholder.png"
                />
              </div>
            </div>
            <div
              v-if="pensum_chart_choice == 'avg_cual'"
              class="chart-title row d-flex"
            >
              <div class="col-12 col-md-9 align-self-center text-center">
                {{ CONFIG.textForTabs[3]["avgCualTitle"] }}
              </div>
              <div class="col-12 col-md-3">
                <HelpVideo
                  src="vid/video6_pensum.mp4"
                  gif_preview="gif_pensum.gif"
                  img_placeholder="pensum_placeholder.png"
                />
              </div>
            </div>

            <div
              v-if="pensum_chart_choice == 'd_cuan'"
              class="chart-title row d-flex"
            >
              <div class="col-12 col-md-9 align-self-center text-center">
                {{ CONFIG.textForTabs[3]["disCuanTitle"] }}
              </div>
              <div class="col-12 col-md-3">
                <HelpVideo
                  src="vid/video6_pensum.mp4"
                  gif_preview="gif_pensum.gif"
                  img_placeholder="pensum_placeholder.png"
                />
              </div>
            </div>

            <div
              v-if="pensum_chart_choice == 'd_cual'"
              class="chart-title row d-flex"
            >
              <div class="col-12 col-md-9 align-self-center text-center">
                {{ CONFIG.textForTabs[3]["disCualTitle"] }}
              </div>
              <div class="col-12 col-md-3">
                <HelpVideo
                  src="vid/video6_pensum.mp4"
                  gif_preview="gif_pensum.gif"
                  img_placeholder="pensum_placeholder.png"
                />
              </div>
            </div>

            <div
              v-if="pensum_chart_choice == 'other'"
              class="chart-title row d-flex"
            >
              <div class="col-12 col-md-9 align-self-center text-center">
                {{ CONFIG.textForTabs[3]["otherTitle"] }}
              </div>
              <div class="col-12 col-md-3">
                <HelpVideo
                  src="vid/video6_pensum.mp4"
                  gif_preview="gif_pensum.gif"
                  img_placeholder="pensum_placeholder.png"
                />
              </div>
            </div>

            <div v-if="pensum_chart_choice == 'avg_cuan'">
              <SalaryIncomeBarChart
                :key="pensum_chart_choice"
                :height="170"
                :chart-data="barChartData"
                :options="pensumBarChartOptions"
              />
            </div>
            <div v-if="pensum_chart_choice == 'avg_cual'">
              <SalaryIncomeBarChart
                :key="pensum_chart_choice"
                :height="170"
                :chart-data="otherBarChartData"
                :options="pensumBarChartOptions2"
              />
            </div>
            <div v-if="pensum_chart_choice == 'd_cuan'">
              <DistributionBarChart
                :height="170"
                :chart-data="distributionBarCharDataCuantitive"
                :colors="distributionBarCharColorsCuantitative"
                :options="DistributionBarChartOptionsCualCuan"
              />
            </div>
            <div v-if="pensum_chart_choice == 'd_cual'">
              <DistributionBarChart
                :height="170"
                :chart-data="distributionBarCharDataCualitative"
                :colors="distributionBarCharColorsCuanlitative"
                :options="DistributionBarChartOptionsCualCuan"
              />
            </div>
            <div v-if="pensum_chart_choice == 'other'">
              <div class="bigchart__pensum-container">
                <div class="bigchart__pensum-chart-container">
                  <PensumChart
                    :chart-data="pensumChartData(career.pensum)"
                    :options="pieChartOptions"
                  />
                </div>
                <PensumHours :hours="career.hours" />
              </div>
            </div>
            <div class="foot-bar-char">
              <ToolbarButton
                :selected="pensum_chart_choice==='other'"
                :suffix="'first'"
                @click="pensum_chart_choice = 'other'"
              >
                Plan de Estudio
              </ToolbarButton>
              <ToolbarButton
                :selected="pensum_chart_choice==='avg_cuan'"
                @click="pensum_chart_choice = 'avg_cuan'"
              >
                Porcentaje cuantitativo
              </ToolbarButton>
              <ToolbarButton
                :selected="pensum_chart_choice==='avg_cual'"
                @click="pensum_chart_choice = 'avg_cual'"
              >
                Porcentaje cualitativo
              </ToolbarButton>
              <ToolbarButton
                :selected="pensum_chart_choice==='d_cuan'"
                @click="pensum_chart_choice = 'd_cuan'"
              >
                Todas las carreras 1
              </ToolbarButton>
              <ToolbarButton
                :selected="pensum_chart_choice==='d_cual'"
                :suffix="'last'"
                @click="pensum_chart_choice = 'd_cual'"
              >
                Todas las carreras 2
              </ToolbarButton>
            </div>
            <p
              v-if="pensum_chart_choice==='avg_cuan'"
              class="textAfterToolbarButtons"
            >
              <span v-html="CONFIG.textForTabs[3]['avg_cuan']" />
            </p>
            <p
              v-if="pensum_chart_choice==='avg_cual'"
              class="textAfterToolbarButtons"
            >
              <span v-html="CONFIG.textForTabs[3]['avg_cual']" />
            </p>
            <p
              v-if="pensum_chart_choice==='d_cuan'"
              class="textAfterToolbarButtons"
            >
              {{ CONFIG.textForTabs[3]["d_cuan"] }}
            </p>
            <p
              v-if="pensum_chart_choice==='d_cual'"
              class="textAfterToolbarButtons"
            >
              {{ CONFIG.textForTabs[3]["d_cual"] }}
            </p>
            <p
              v-if="pensum_chart_choice==='other'"
              class="textAfterToolbarButtons"
            >
              <span v-html="CONFIG.textForTabs[3]['other']" />
            </p>
          </div>
        </template>
      </AccordionOrTabs>
    </div>
  </div>
</template>
<script>
import CONFIG from '../../config';
import AccordionOrTabs from './AccordionOrTabs.vue';
import SalaryQuestion from './SalaryQuestion.vue';
import EmployabilityQuestion from './EmployabilityQuestion.vue';
import GradesQuestion from './GradesQuestion.vue';
import SalaryIncomeBarChart from '../../components/Charts/SalaryIncomeBarChart.vue';
import PartnersBarChart from '../../components/Charts/PartnersBarChart.vue';
import DistributionBarChart from '../../components/Charts/DistributionBarChart.vue';
import PensumChart from '../../components/Charts/PensumChart.vue';
import PensumHours from '../../components/PensumHours.vue';
import ToolbarButton from '../../components/ToolbarButton.vue';
import CareerPlaceholder from './CareerPlaceholder.vue';
import { careersService, studentsService } from '../../_services';
import HelpChartVideo from './HelpChartVideo.vue';
import HelpVideo from '../Favorites/HelpVideo.vue';
import {EventBus} from "../../components/EventBus";

export default {
    name: 'CareersShow',
    components: {
        HelpVideo,
        AccordionOrTabs,
        CareerPlaceholder,
        DistributionBarChart,
        EmployabilityQuestion,
        GradesQuestion,
        HelpChartVideo,
        PartnersBarChart,
        PensumChart,
        PensumHours,
        SalaryIncomeBarChart,
        SalaryQuestion,
        ToolbarButton,
    },
    props: {
        suggestionId: {
            type: Number,
            required: true,
        },
        answeredQuiz: {
            type: Boolean,
            required: true,
        },
        answerQuestion: {
            type: Boolean,
            required: true,
        },
        careerUuid: {
            type: String,
            required: true,
        },
        careerId: {
            type: Number,
            required: true,
        },
        uiConfig: {
            type: Number,
            required: true,
        },
    },
    data() {
        this.CONFIG = CONFIG;
        return {
            student_overlay_info: false,
            showOverlay: false,
            career_mean: 0,
            career_employability_mean: 0,
            career_grades_mean: {},
            pensum_chart_choice: 'other',
            starred: false,
            ask_question: [false, false, false, false],
            lock_tabs: true,
            display_chart_group: {
                line: false,
                bar: false,
                video: false,
                line_button: false,
                bar_button: false,
                video_button: false,
            },
            is_line_chart: true,
            loading_career: false,
            loading_chart_data: false,
            answer_question: true,
            local_answered_question: false,
            answered_careers: [],
            tabs: [
                {
                    icon: 'money-bill',
                    label: 'Salarios',
                },
                {
                    icon: 'briefcase',
                    label: 'Empleabilidad',
                },
                {
                    icon: 'users',
                    label: 'Pruebas Nacionales',
                },
                {
                    icon: 'chart-pie',
                    label: 'Pensum',
                },
            ],
            currentTab: 0,
            career: {
                name: '',
            },
            salary_error: false,
            emp_error: false,
            grades_error: false,
            pensum_error: false,
            distributionBarCharData: [],
            distributionBarCharDataCuantitive: [],
            distributionBarCharDataCualitative: [],
            distributionBarCharColors: [],
            distributionBarCharColorsCuantitative: [],
            distributionBarCharColorsCuanlitative: [],
            lineChartData: {},
            otherLineChartData: {},
            barChartData: {},
            otherBarChartData: {},
            DistributionBarChartOptionsCualCuan: {
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        title(tooltipItem, data) {
                            const { index } = tooltipItem[0];
                            let points = data.labels[index];
                            const formatter = new Intl.NumberFormat('es-Es', { maximumSignificantDigits: 3 });
                            const percent = formatter.format(data.datasets[0].data[index]);
                            if (points.indexOf(' ') > 0) {
                                points = points.slice(-points.indexOf(' '));
                                return `Promedio Carrera: ${percent}%`;
                            }
                            return `${percent}%`;
                        },
                        label() {
                            return '';
                        },
                        footer() {
                            return '';
                        },
                    },
                },
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Distribución',
                            },
                            ticks: {
                                callback(value) {
                                    return `${value}%`;
                                },
                            },
                        },
                    ],
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: false,
                            },
                            ticks: {
                                min: 0,
                                stepSize: 5,
                                callback(value) {
                                    return `${value}%`;
                                },
                            },
                        },
                    ],
                },
            },
            partnersBarChartOptions: {
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        title(tooltipItem, data) {
                            const { index } = tooltipItem[0];
                            const points = data.labels[index];
                            const formatter = new Intl.NumberFormat('es-Es', { maximumSignificantDigits: 3 });
                            const percent = formatter.format(data.datasets[0].data[index]);
                            if (points.search('Mi puntaje') !== -1) {
                                return points;
                            }
                            return `El ${percent}% obtuvo cerca de ${points} puntos`;
                        },
                        label() {
                            return '';
                        },
                        footer() {
                            return '';
                        },
                    },
                },
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: '% de egresados',
                            },
                            ticks: {
                                min: 0,
                                // max: 15,
                                stepSize: 10,
                                callback(value) {
                                    return `${value}%`;
                                },
                            },
                        },
                    ],
                },
            },
            barChartOptions: {
                // layout: {
                //     padding: {
                //         top: 70,
                //     },
                // },
                responsive: true,
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                tooltips: {
                    callbacks: {
                        footer(tooltipItem, data) {
                            if (tooltipItem[0].index === 0) {
                                return `en la carrera ${
                                    data.datasets[0].label[0]
                                }`;
                            }
                            return 'de otras carreras de la misma área de estudio';
                        },
                        label() {
                            return '';
                        },
                        title() {
                            return 'Salario Promedio';
                        },
                    },
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        borderRadius: 4,
                        color: '#888',
                        font: {
                            size: 11,
                            weight: 600,
                        },
                        textAlign: 'center',
                    },
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            maxBarThickness: 200,
                        },
                    ],
                    yAxes: [
                        {
                            scaleLabel: {
                                display: true,
                                labelString: 'Salario (RD$)',
                            },
                            id: 'y-axis-0',
                            ticks: {
                                min: 0,
                                max: 65000,
                                callback(value, index, values) {
                                    const formatter = new Intl.NumberFormat();
                                    const aux = formatter.format(
                                        value.toString(),
                                    );
                                    return `${aux}`;
                                },
                            },
                        },
                    ],
                },
            },
            employBarChartOptions: {
                // layout: {
                //     padding: {
                //         top: 70,
                //     },
                // },
                responsive: true,
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                tooltips: {
                    callbacks: {
                        footer(tooltipItem, data) {
                            if (tooltipItem[0].index === 0) {
                                return `en la carrera ${
                                    data.datasets[0].label[0]
                                }`;
                            }
                            return 'de otras carreras de la misma área de estudio';
                        },
                        label() {
                            return '';
                        },
                        title() {
                            return 'Empleabilidad Promedio';
                        },
                    },
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        borderRadius: 4,
                        color: 'white',
                        backgroundColor: 'default',
                        font: {
                            size: 11,
                            weight: 600,
                        },
                        textAlign: 'center',
                    },
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            maxBarThickness: 200,
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            ticks: {
                                min: 0,
                                max: 11,
                                stepSize: 1,
                                callback(value, index, values) {
                                    return value === 11 ? '' : value;
                                },
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Empleabilidad',
                            },
                        },
                    ],
                },
            },
            gradeBarChartOptions: {
                // layout: {
                //     padding: {
                //         top: 70,
                //     },
                // },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        footer(tooltipItem, data) {
                            return `${
                                data.datasets[tooltipItem[0].datasetIndex].label
                            } ${tooltipItem[0].value}`;
                        },
                        label() {
                            return '';
                        },
                        title(tooltipItem, data) {
                            return data.labels[tooltipItem[0].index];
                        },
                    },
                },
                responsive: true,
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        borderRadius: 4,
                        color: '#888',
                        font: {
                            size: 11,
                            weight: 600,
                        },
                        textAlign: 'center',
                    },
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            maxBarThickness: 60,
                        },
                    ],
                    yAxes: [
                        {
                            scaleLabel: {
                                display: true,
                                labelString: 'Puntajes Pruebas Nacionales',
                            },
                            id: 'y-axis-0',
                            ticks: {
                                min: 0,
                                max: 30,
                            },
                        },
                    ],
                },
            },
            pensumBarChartOptions: {
                responsive: true,
                tooltips: {
                    enabled: true,
                    callbacks: {
                        footer(tooltipItem, data) {
                            return data.labels[tooltipItem[0].index];
                        },
                        label() {
                            return '';
                        },
                        title() {
                            return '';
                        },
                    },
                },
                // layout: {
                //     padding: {
                //         top: 70,
                //     },
                // },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        borderRadius: 4,
                        color: '#888',
                        font: {
                            size: 11,
                            weight: 600,
                        },
                        textAlign: 'center',
                    },
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            maxBarThickness: 200,
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            ticks: {
                                min: 0,
                                max: 100,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Porcentaje de cursos cuantitativos de la carrera',
                            },
                        },
                    ],
                },
            },
            pensumBarChartOptions2: {
                responsive: true,
                tooltips: {
                    enabled: true,
                    callbacks: {
                        footer(tooltipItem, data) {
                            return data.labels[tooltipItem[0].index];
                        },
                        label() {
                            return '';
                        },
                        title() {
                            return '';
                        },
                    },
                },
                // layout: {
                //     padding: {
                //         top: 70,
                //     },
                // },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        borderRadius: 4,
                        color: '#888',
                        font: {
                            size: 11,
                            weight: 600,
                        },
                        textAlign: 'center',
                    },
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            maxBarThickness: 200,
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            ticks: {
                                min: 0,
                                max: 100,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Porcentaje de cursos cualitativos de la carrera',
                            },
                        },
                    ],
                },
            },
            pensumLineChartOptions: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                legend: {
                    onClick: e => e.stopPropagation(),
                },
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            type: 'linear',
                            position: 'bottom',
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Porcentaje',
                            },
                            ticks: {
                                min: 0,
                                max: 100,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            type: 'linear',
                            position: 'left',
                            display: false,
                        },
                    ],
                },
            },
            lineChartOptions: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            type: 'linear',
                            position: 'bottom',
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Salario (RD$)',
                            },
                            ticks: {
                                min: 0,
                                callback(value, index, values) {
                                    const formatter = new Intl.NumberFormat();
                                    const aux = formatter.format(
                                        value.toString(),
                                    );
                                    return `${aux}`;
                                },
                            },
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            type: 'linear',
                            position: 'left',
                            display: false,
                        },
                    ],
                },
            },
            gradeLineChartOptions: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                annotation: {
                    events: ['click', 'dblclick', 'mouseover', 'mouseout'],
                    annotations: [],
                },
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            type: 'linear',
                            position: 'bottom',
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Puntaje Pruebas Nacionales',
                            },
                            ticks: {
                                min: 0,
                                max: 30,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            type: 'linear',
                            position: 'left',
                            display: false,
                        },
                    ],
                },
            },
            pieChartOptions: {
                responsive: true,
                legend: {
                    display: false,
                },
                tooltips: {
                    bodyFontSize: 12,
                },
            },
        };
    },
    computed: {
        error() {
            return (
                this.salary_error
                || this.pensum_error
                || this.grades_error
                || this.emp_error
                || this.currentTab === 3
            );
        },
        ImageClassIfMobile() {
            const width = window.innerWidth;
            if (width < CONFIG.responsive.minWithInfoChart) {
                return 'empty-image w-100';
            }
            return 'empty-image';
        },
    },
    watch: {
        currentTab() {
            this.loading_chart_data = true;
            this.getData();
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.loading_career = true;
            this.student_overlay_info = this.$store.getters['authentication/video_trigger'];
            if (this.answeredQuiz) {
                this.answer_question = false;
                this.lock_tabs = false;
            }
            careersService.getCareer(
                this.careerId,
            ).then((response) => {
                this.career = response.data;
                // Marcamos carrera visitada
                this.$store.dispatch('clippyNotifications/addVisitCareer', this.career.name);
                this.currentTab = this.uiConfig;
                const answeredQuestions = this.$store.getters['careers/answered_careers'];
                if (!this.answeredQuiz && !answeredQuestions.includes(this.career.name)) {
                    this.ask_question[this.uiConfig] = true;
                } else {
                    this.lock_tabs = false;
                }
                this.starred = this.career.starred;
                switch (this.$store.getters['authentication/chart_group']) {
                case 1:
                    this.display_chart_group.line = true;
                    break;
                case 2:
                    this.display_chart_group.bar = true;
                    break;
                case 4:
                    this.display_chart_group.line = false;
                    this.display_chart_group.bar = true;
                    this.display_chart_group.line_button = true;
                    this.display_chart_group.bar_button = true;
                    break;
                default:
                    this.display_chart_group.line = false;
                    this.display_chart_group.bar = true;
                    this.display_chart_group.video = false;
                    this.display_chart_group.line_button = true;
                    this.display_chart_group.bar_button = true;
                    this.display_chart_group.video_button = true;
                    break;
                }
                this.getData();
            }).finally(() => {
                this.loading_career = false;
            });
        });
        EventBus.$on('closeOverlayVideo', this.removeOverlayVideo);
    },
    destroyed() {
        this.$store.dispatch(
            'clippyNotifications/leaveCareer',
            this.career.name,
        );
    },
    methods: {
        removeOverlayVideo() {
            this.showOverlay = false;
            if (this.student_overlay_info){
                studentsService
                    .patchStudent(
                        this.$store.getters['authentication/student_uuid'],
                        { video_trigger: false },
                    ).then(() => {
                        this.$store.dispatch('authentication/triggeredVideoOverlay');
                    });
            }
        },
        changeCurrentTab(tab) {
            this.currentTab = tab;
        },
        pensumChartData(pensum) {
            return {
                datasets: [
                    {
                        backgroundColor: [
                            CONFIG.COLORS.pensum.cuantitative,
                            CONFIG.COLORS.pensum.cualitative,
                            CONFIG.COLORS.pensum.optative,
                            CONFIG.COLORS.pensum.profesional,
                        ],
                        data: Object.values(pensum).map(v => Number(v).toFixed(2)),
                    },
                ],
                labels: Object.keys(pensum),
            };
        },
        showGraph(button) {
            if (button === 'line') {
                this.display_chart_group.line = true;
                this.display_chart_group.bar = false;
                this.display_chart_group.video = false;
            } else if (button === 'bar') {
                this.display_chart_group.line = false;
                this.display_chart_group.bar = true;
                this.display_chart_group.video = false;
            }
        },
        toggleFavorites() {
            this.starred = !this.starred;
            if (this.starred) {
                studentsService
                    .postCareerPreference(
                        this.$store.getters['authentication/student_uuid'],
                        { career: this.career.id },
                    )
                    .then(() => {
                        const careerName = this.$options.filters.capitalize(
                            this.career.name,
                        );
                        this.$emit('toggle-favorites', this.starred);
                        this.$store.commit('authentication/addStar');
                        this.$store.dispatch('notifications/add', {
                            title: 'Nueva carrera favorita',
                            message: `Se ha agregado la carrera ${careerName} a tu lista de
                            favoritos`,
                        });
                    });
            } else {
                studentsService
                    .deleteCareerPreference(
                        this.$store.getters['authentication/student_uuid'],
                        this.careerUuid,
                    )
                    .then(() => {
                        this.$emit('toggle-favorites', this.starred);
                        this.$store.commit('authentication/removeStar');
                    });
            }
        },
        AnswerCallback(question, response) {
            this.$store.dispatch('careers/addAnsweredCareer', this.career.name);
            this.lock_tabs = false;
            this.answer_question = false;
            this.local_answered_question = true;

            this.ask_question = [false, false, false, false];

            const studentResponse = {
                salary: null,
                employability: null,
                grades: null,
            };
            if (question === 'salary') {
                studentResponse[question] = response;
            } else if (question === 'employability') {
                studentResponse[question] = response;
            } else if (question === 'grades') {
                studentResponse[question] = response;
            }

            studentsService.postQuestionResponse(
                this.$store.getters['authentication/student_uuid'],
                {
                    career_suggestion: this.suggestionId,
                    response: studentResponse,
                },
            );
        },
        getData() {
            if (this.currentTab === 0) {
                const chartGroup = this.$store.getters[
                    'authentication/chart_group'
                ];
                if (chartGroup !== 1 && chartGroup !== 2 && chartGroup !== 4) {
                    this.$store.dispatch(
                        'clippyNotifications/addDirectMessage',
                        'WATCH_VIDEO',
                    );
                    this.showOverlay = true;
                }
                this.getSalaryData();
            } else if (this.currentTab === 1) {
                this.getEmployabilityData();
            } else if (this.currentTab === 2) {
                this.getGradesData();
            } else if (this.currentTab === 3) {
                this.answer_question = false;
                this.getPensumData();
            }
        },
        getSalaryData() {
            const barChartData = {
                labels: [
                    this.parseNameIfMobile(this.career.name, 'Carrera'),
                    this.parseNameIfMobile(this.career.area_name, 'Área'),
                ],
                datasets: [
                    {
                        label: [
                            this.$options.filters.capitalize(this.career.name),
                            this.$options.filters.capitalize(
                                this.$options.filters.lowercase(
                                    this.career.area_name,
                                ),
                            ),
                        ],
                        backgroundColor: [
                            CONFIG.COLORS.salary.career,
                            CONFIG.COLORS.salary.area,
                        ],
                        borderColor: [
                            CONFIG.COLORS.salary.career,
                            CONFIG.COLORS.salary.area,
                        ],
                        data: [],
                    },
                ],
            };
            this.loading_chart_data = true;
            studentsService.careerSalaryData(
                this.$store.getters['authentication/student_uuid'],
                this.careerUuid,
            ).then((response) => {
                const formatter = new Intl.NumberFormat('es-Es', { maximumSignificantDigits: 3 });
                const datasChart = [];
                if (response.data.hist_pdf && response.data.hist_pdf.length) {
                    datasChart.push(response.data.hist_pdf);
                    datasChart[0].title = 'Carrera';
                    datasChart[0].color = 'career';
                }
                if (response.data.hist_area_pdf && response.data.hist_area_pdf.length) {
                    const { length } = datasChart;
                    datasChart.push(response.data.hist_area_pdf);
                    datasChart[length].title = 'Área';
                    datasChart[length].color = 'area';
                }
                const distributionBarCharData = [];
                const distributionBarCharColors = [];
                datasChart.forEach((i) => {
                    distributionBarCharColors.push(CONFIG.COLORS.salary[i.color]);
                    let grades = i.map(pdf => ({
                        label: pdf[0],
                        value: pdf[1],
                    }));
                    grades = grades.filter(e => e.label > 0);
                    const ordered = grades
                        .sort((a, b) => a.label - b.label);
                    const dataNearMyMean = grades.map((grade) => {
                        const label = Math.abs(grade.label - i.career_mean_income);
                        return { value: grade.value, label };
                    });

                    const myCareer = dataNearMyMean.sort((a, b) => b.value - a.value)[0];
                    const colors = [];
                    const labels = ordered.map((item) => {
                        if (item.value === myCareer.value) {
                            const color = CONFIG.COLORS.shadows[i.color];
                            colors.push(color);
                            return `Promedio ${this.$options.filters.currency(item.label)} RD$`;
                        }
                        colors.push(CONFIG.COLORS.salary[i.color]);
                        return `${this.$options.filters.currency(item.label)} RD$`;
                    });
                    distributionBarCharData.push({
                        title: i.title,
                        labels,
                        datasets: [
                            {
                                label: i.title,
                                backgroundColor: colors,
                                borderColor: CONFIG.COLORS.salary[i.color],
                                data: ordered.map(item => item.value),
                            },
                        ],
                    });
                });
                const widthScreen = window.innerWidth;
                this.career_mean = response.data.career_mean_income;
                this.salary_error = false;

                barChartData.datasets[0].data = [
                    response.data.mean ? response.data.mean : 0,
                    response.data.area_mean,
                ];

                this.lineChartOptions.annotation.annotations = [];
                if (
                    widthScreen
                        >= this.CONFIG.responsive.minWithInfoChart
                ) {
                    // this.lineChartOptions.annotation.annotations.push(
                    //     {
                    //         borderColor: '#999',
                    //         borderWidth: 2,
                    //         mode: 'vertical',
                    //         type: 'line',
                    //         value: response.data.margins.min,
                    //         scaleID: 'x-axis-0',
                    //         label: {
                    //             yAdjust: 40,
                    //             content: 'Carrera con menor salario promedio',
                    //             enabled: true,
                    //         },
                    //     },
                    // );
                    // this.lineChartOptions.annotation.annotations.push(
                    //     {
                    //         borderColor: '#999',
                    //         borderWidth: 2,
                    //         mode: 'vertical',
                    //         type: 'line',
                    //         value: response.data.margins.avg,
                    //         scaleID: 'x-axis-0',
                    //         label: {
                    //             content: 'Carrera con salario promedio',
                    //             enabled: true,
                    //         },
                    //     },
                    // );
                    // this.lineChartOptions.annotation.annotations.push(
                    //     {
                    //         borderColor: '#999',
                    //         borderWidth: 2,
                    //         mode: 'vertical',
                    //         type: 'line',
                    //         value: response.data.margins.max,
                    //         scaleID: 'x-axis-0',
                    //         label: {
                    //             yAdjust: -40,
                    //             content: 'Carrera con mayor salario promedio',
                    //             enabled: true,
                    //         },
                    //     },
                    // );

                    this.barChartOptions.annotation.annotations = [];
                    this.barChartOptions.annotation.annotations.push({
                        borderColor: '#999',
                        borderWidth: 2,
                        borderDash: [3, 3],
                        mode: 'horizontal',
                        type: 'line',
                        value: response.data.margins.min,
                        scaleID: 'y-axis-0',
                        label: {
                            content: 'Carrera con menor salario promedio',
                            enabled: true,
                        },
                    });
                    this.barChartOptions.annotation.annotations.push({
                        borderColor: '#999',
                        borderWidth: 2,
                        borderDash: [3, 3],
                        mode: 'horizontal',
                        type: 'line',
                        value: response.data.margins.avg,
                        scaleID: 'y-axis-0',
                        label: {
                            content: 'Carrera con salario promedio',
                            enabled: true,
                        },
                    });
                    this.barChartOptions.annotation.annotations.push({
                        borderColor: '#999',
                        borderWidth: 2,
                        borderDash: [3, 3],
                        mode: 'horizontal',
                        type: 'line',
                        value: response.data.margins.max,
                        scaleID: 'y-axis-0',
                        label: {
                            content: 'Carrera con mayor salario promedio',
                            enabled: true,
                        },
                    });
                }
                this.distributionBarCharColors = distributionBarCharColors;
                this.distributionBarCharData = distributionBarCharData;
                this.barChartData = barChartData;
            })
                .catch(() => {
                    this.salary_error = true;
                })
                .finally(() => {
                    this.loading_chart_data = false;
                });
            this.barChartOptions.plugins.datalabels.formatter = function (value, context) {
                if (!value) {
                    return 'No tenemos\nsuficiente\ninformación';
                }
                return '';
            };
        },
        getEmployabilityData() {
            const barChartData = {
                labels: [
                    this.parseNameIfMobile(this.career.name, 'Carrera'),
                    this.parseNameIfMobile(this.career.area_name, 'Área'),
                ],
                datasets: [
                    {
                        label: [
                            this.$options.filters.capitalize(this.career.name),
                            this.$options.filters.capitalize(
                                this.$options.filters.lowercase(
                                    this.career.area_name,
                                ),
                            ),
                        ],
                        backgroundColor: [
                            CONFIG.COLORS.salary.career,
                            CONFIG.COLORS.salary.area,
                        ],
                        borderColor: [
                            CONFIG.COLORS.salary.career,
                            CONFIG.COLORS.salary.area,
                        ],
                        data: [],
                    },
                ],
            };
            this.loading_chart_data = true;
            studentsService
                .careerEmployabilityData(
                    this.$store.getters['authentication/student_uuid'],
                    this.careerUuid,
                )
                .then((response) => {
                    this.emp_error = false;
                    this.career_employability_mean = response.data.mean;
                    barChartData.datasets[0].data = [
                        response.data.mean ? response.data.mean : 0,
                        response.data.area_mean,
                    ];

                    this.employBarChartOptions.annotation.annotations = [];
                    const widthScreen = window.innerWidth;

                    if (
                        widthScreen
                        >= this.CONFIG.responsive.minWithInfoChart
                    ) {
                        this.employBarChartOptions.annotation.annotations.push({
                            borderColor: '#999',
                            borderWidth: 2,
                            borderDash: [3, 3],
                            mode: 'horizontal',
                            type: 'line',
                            value: response.data.margins.min,
                            scaleID: 'y-axis-0',
                            label: {
                                content:
                                    'Carrera con menor empleabilidad promedio',
                                enabled: true,
                            },
                        });
                        this.employBarChartOptions.annotation.annotations.push({
                            borderColor: '#999',
                            borderWidth: 2,
                            borderDash: [3, 3],
                            mode: 'horizontal',
                            type: 'line',
                            value: response.data.margins.avg,
                            scaleID: 'y-axis-0',
                            label: {
                                content: 'Carrera con empleabilidad promedio',
                                enabled: true,
                            },
                        });
                        this.employBarChartOptions.annotation.annotations.push({
                            borderColor: '#999',
                            borderWidth: 2,
                            borderDash: [3, 3],
                            mode: 'horizontal',
                            type: 'line',
                            value: response.data.margins.max,
                            scaleID: 'y-axis-0',
                            label: {
                                content:
                                    'Carrera con mayor empleabilidad promedio',
                                enabled: true,
                            },
                        });
                    }
                    this.barChartData = barChartData;
                })
                .catch(() => {
                    this.emp_error = true;
                })
                .finally(() => {
                    this.loading_chart_data = false;
                });
            this.employBarChartOptions.plugins.datalabels.formatter = function (
                value,
            ) {
                if (!value) {
                    return 'No tenemos\nsuficiente\ninformación';
                }
                if (value <= 4) {
                    return 'Empleabilidad\nBaja';
                }
                if (value > 7) {
                    return 'Empleabilidad\nAlta';
                }

                return 'Empleabilidad\nMedia';
            };
        },
        getGradesData() {
            const barChartData = {
                labels: [],
                datasets: [],
            };
            const lineChartData = {
                labels: [],
                datasets: [],
            };
            studentsService
                .careerGradesData(
                    this.$store.getters['authentication/student_uuid'],
                    this.careerUuid,
                )
                .then((response) => {
                    this.career_grades_mean = Object.values(response.data);
                    this.grades_error = false;
                    const dataset = {
                        label: '',
                        backgroundColor: '#0000FF',
                        borderColor: '#0000FF',
                        fill: false,
                        pointRadius: 0,
                        data: [],
                    };
                    this.gradeLineChartOptions.annotation.annotations = [];
                    const colors = Object.keys(CONFIG.COLORS.partners).map(
                        key => CONFIG.COLORS.partners[key],
                    );

                    let aux = 0;
                    for (
                        let index = 0;
                        index < Object.values(response.data).length;
                        index += 1
                    ) {
                        const responseData = Object.values(response.data)[
                            index
                        ];

                        const tempDataset = JSON.parse(JSON.stringify(dataset));
                        tempDataset.data = responseData.pdf.map(datum => ({
                            x: datum[0],
                            y: datum[1],
                        }));
                        tempDataset.label = responseData.name;
                        tempDataset.backgroundColor = colors[aux];
                        tempDataset.borderColor = colors[aux];
                        if (
                            tempDataset.label === 'Ciencias Sociales'
                            || tempDataset.label === 'Ciencias Naturales'
                        ) {
                            tempDataset.hidden = true;
                        }
                        lineChartData.datasets.push(tempDataset);

                        this.gradeLineChartOptions.annotation.annotations.push({
                            borderColor: colors[aux],
                            borderWidth: 6,
                            type: 'box',
                            xMin: responseData.student_grade - 0.05,
                            xMax: responseData.student_grade + 0.05,
                            yMin: responseData.student_grade_y - 0.0005,
                            yMax: responseData.student_grade_y + 0.0005,
                            xScaleID: 'x-axis-0',
                            yScaleID: 'y-axis-0',
                        });

                        aux += 1;
                    }
                    this.lineChartData = lineChartData;

                    const barDatasets = [
                        {
                            label: '',
                            backgroundColor: colors.map(color => `${color}88`),
                            borderColor: colors,
                            data: [],
                        },
                        {
                            label: '',
                            backgroundColor: colors,
                            borderColor: colors,
                            borderWidth: 2,
                            data: [],
                        },
                    ];
                    for (
                        let index = 0;
                        index < Object.values(response.data).length;
                        index += 1
                    ) {
                        const responseData = Object.values(response.data)[
                            index
                        ];
                        const nameGrade = responseData.name;
                        barChartData.labels.push(nameGrade);
                        barDatasets[0].data.push(responseData.student_grade);
                        barDatasets[0].label = 'Mi puntaje';
                        barDatasets[1].data.push(Math.trunc(responseData.avg));
                        barDatasets[1].label = 'Promedio\nCarrera';
                    }
                    barChartData.datasets = barDatasets;
                    this.barChartData = barChartData;
                })
                .catch(() => {
                    this.grades_error = true;
                })
                .finally(() => {
                    this.loading_chart_data = false;
                });
            const widthScreen = window.innerWidth;

            if (widthScreen >= this.CONFIG.responsive.minWithInfoChart) {
                this.gradeBarChartOptions.plugins.datalabels.formatter = function (value, context) {
                    return context.dataset.label;
                };
            } else {
                this.gradeBarChartOptions.scales.xAxes[0].labels = this.CONFIG.responsive
                    .compressDictionary;
                this.gradeBarChartOptions.plugins.datalabels.formatter = function () {
                    return '';
                };
            }
        },
        getPensumData() {
            const lineChartData = {
                labels: [],
                datasets: [
                    {
                        label: 'Cuantitativo',
                        backgroundColor: CONFIG.COLORS.salary.career,
                        borderColor: CONFIG.COLORS.salary.career,
                        fill: false,
                        pointRadius: 0,
                        data: [],
                    },
                ],
            };

            const otherLineChartData = {
                labels: [],
                datasets: [
                    {
                        label: 'Cualitativo',
                        backgroundColor: CONFIG.COLORS.salary.area,
                        borderColor: CONFIG.COLORS.salary.area,
                        fill: false,
                        pointRadius: 0,
                        data: [],
                    },
                ],
            };

            let cleanedCareerName = this.$options.filters.capitalize(
                this.career.name,
            );
            let cleanedAreaName = this.$options.filters.capitalize(
                this.$options.filters.lowercase(this.career.area_name),
            );

            const threshold = 8;
            let counter = 0;
            for (let index = 0; index < cleanedCareerName.length; index += 1) {
                if (
                    cleanedCareerName.charAt(index) === ' '
                    && counter >= threshold
                ) {
                    cleanedCareerName = cleanedCareerName.replace(
                        cleanedCareerName.charAt(index),
                        '\n',
                    );
                    counter = -1;
                }
                counter += 1;
            }

            counter = 0;
            for (let index = 0; index < cleanedAreaName.length; index += 1) {
                if (
                    cleanedAreaName.charAt(index) === ' '
                    && counter >= threshold
                ) {
                    cleanedAreaName = cleanedAreaName.replace(
                        cleanedAreaName.charAt(index),
                        '\n',
                    );
                    counter = -1;
                }
                counter += 1;
            }

            const barChartData = {
                labels: [cleanedCareerName, cleanedAreaName],
                datasets: [
                    {
                        label: '',
                        backgroundColor: [
                            CONFIG.COLORS.pensum.cuantitative,
                            `${CONFIG.COLORS.pensum.cuantitative}88`,
                        ],
                        borderColor: [
                            CONFIG.COLORS.pensum.cuantitative,
                            CONFIG.COLORS.pensum.cuantitative,
                        ],
                        data: [],
                    },
                ],
            };

            const otherBarChartData = {
                labels: [cleanedCareerName, cleanedAreaName],
                datasets: [
                    {
                        label: '',
                        backgroundColor: [
                            CONFIG.COLORS.pensum.cualitative,
                            `${CONFIG.COLORS.pensum.cualitative}88`,
                        ],
                        borderColor: [
                            CONFIG.COLORS.pensum.cualitative,
                            CONFIG.COLORS.pensum.cualitative,
                        ],
                        data: [],
                    },
                ],
            };

            studentsService
                .careerPensumData(
                    this.$store.getters['authentication/student_uuid'],
                    this.careerUuid,
                )
                .then((response) => {
                    const formatter = new Intl.NumberFormat('es-Es',
                        { maximumSignificantDigits: 3 });
                    const datasChart = [];
                    if (response.data.hist_quant_grades_pdf
                      && response.data.hist_quant_grades_pdf.length) {
                        datasChart.push(response.data.hist_quant_grades_pdf);
                        datasChart[0].title = 'Cuantitativo';
                        datasChart[0].color = 'career';
                    }
                    if (response.data.hist_quali_grades_pdf
                      && response.data.hist_quali_grades_pdf.length) {
                        datasChart.push(response.data.hist_quali_grades_pdf);
                        datasChart[1].title = 'Cualitativo';
                        datasChart[1].color = 'area';
                    }
                    const distributionBarCharData = [];
                    const distributionBarCharColors = [];
                    datasChart.forEach((i, index) => {
                        distributionBarCharColors.push(CONFIG.COLORS.salary[i.color]);
                        let grades = i.map(pdf => ({
                            label: pdf[0],
                            value: pdf[1],
                        }));
                        grades = grades.filter(e => e.label > 0);
                        const ordered = grades
                            .sort((a, b) => a.label - b.label);
                        const mean = index ? response.data.cuantitative : response.data.cualitative;
                        const dataNearMyMean = ordered.map((bar, index) => {
                            const label = Math.abs(bar.label - mean);
                            return { index, label };
                        });

                        // Find 'equal' value
                        const myCareer = dataNearMyMean.sort((a, b) => a.label - b.label)[0];
                        const colors = [];
                        let color;
                        const labels = ordered.map((item, index2) => {
                            if (index2 === myCareer.index) {
                                color = CONFIG.COLORS.shadows[i.color];
                                colors.push(color);
                                return `Esta carrera ${formatter.format(item.label)}`;
                            }
                            color = CONFIG.COLORS.salary[i.color];
                            colors.push(color);
                            return formatter.format(item.label);
                        });
                        distributionBarCharData.push({
                            title: i.title,
                            labels,
                            datasets: [
                                {
                                    label: i.title,
                                    backgroundColor: colors,
                                    borderColor: CONFIG.COLORS.salary[i.color],
                                    data: ordered.map(item => item.value),
                                },
                            ],
                        });
                    });
                    this.pensum_error = false;
                    lineChartData.datasets[0].data = response.data.cuantitative_pdf.map(
                        (datum) => {
                            lineChartData.labels.push(Math.trunc(datum[0]));
                            return { x: datum[0], y: datum[1] };
                        },
                    );
                    otherLineChartData.datasets[0].data = response.data.cualitative_pdf.map(
                        (datum) => {
                            lineChartData.labels.push(Math.trunc(datum[0]));
                            return { x: datum[0], y: datum[1] };
                        },
                    );
                    barChartData.datasets[0].data = [
                        response.data.cuantitative,
                        response.data.cuantitative_mean,
                    ];

                    otherBarChartData.datasets[0].data = [
                        response.data.cualitative,
                        response.data.cualitative_mean,
                    ];

                    this.pensumLineChartOptions.annotation.annotations = [];
                    this.distributionBarCharColorsCuantitative = [distributionBarCharColors[0]];
                    this.distributionBarCharColorsCuanlitative = [distributionBarCharColors[1]];
                    this.distributionBarCharDataCuantitive = [distributionBarCharData[0]];
                    this.distributionBarCharDataCualitative = [distributionBarCharData[1]];
                    this.barChartData = barChartData;
                    this.otherBarChartData = otherBarChartData;
                    this.lineChartData = lineChartData;
                    this.otherLineChartData = otherLineChartData;
                })
                .catch(() => {
                    this.pensum_error = true;
                })
                .finally(() => {
                    this.loading_chart_data = false;
                });
            if (window.innerWidth < CONFIG.responsive.minWithInfoChart) {
                this.pensumBarChartOptions.scales.xAxes[0].labels = [
                    'Área',
                    'Carrera',
                ];
                this.pensumBarChartOptions2.scales.xAxes[0].labels = [
                    'Área',
                    'Carrera',
                ];
            }
            this.pensumBarChartOptions.plugins.datalabels.formatter = function (
                value,
                context,
            ) {
                return context.dataset.label;
            };
            this.pensumBarChartOptions2.plugins.datalabels.formatter = function (
                value,
                context,
            ) {
                return context.dataset.label;
            };
        },
        parseNameIfMobile(name, type) {
            const width = window.innerWidth;
            if (width < CONFIG.responsive.minWithInfoChart && name.length > 10) {
                return type;
            } if (type === 'Carrera') {
                return this.parseCareerName(name);
            } if (type === 'Área') {
                return this.parseAreaName(name);
            }
            return '';
        },
        parseAreaName(name) {
            return this.$options.filters.capitalize(
                this.$options.filters.lowercase(name),
            );
        },
        parseCareerName(name) {
            return this.$options.filters.capitalize(name);
        },
    },
};
</script>
<style lang="scss">
  .overlay_class3 {
    position: relative;
    z-index: 99999;

    &--active {
      opacity: 1;
    }
  }
  #overlay3 {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 9999;
    pointer-events: none;
    opacity: 0;
    transition: opacity .3s ease;
  }
.chart-title {
    font-size: 1.2rem;
    margin: 1rem;
    text-align: left;
}
.chartSubtitle {
    // padding: 10px;
    text-align: center;
    display: none;
}
.textAfterToolbarButtons {
    padding-top: 10px;
    font-size: 12px;
    max-width: 400px;
    margin: 0 auto;
}
.father-of-toolbarbuttons {
    width: 100%;
    text-align: center;
}
.foot-bar-char {
    margin-top: 20px;
    display: inline-block;
}
.explorer-show__title {
    font-size: 1.3rem;
    margin: 0.5rem 0;
    line-height: 1;
    @media (min-width: 768px) {
        font-size: 2.0rem;
        margin: 0;
    }
}
.explorer-show__subtitle{
  margin-bottom: 1rem;
  color: #4A4A4A;
}
.empty-image {
    margin: 20px;
}
.bigchart {
    &__pensum-container {
        @media (min-width: 992px) and (max-width: 1199px) {
            text-align: center;
            margin: 0 auto;
        }
    }

    &__pensum-chart-container {
        max-width: 200px;
        margin: 1rem auto;
    }
}
</style>
